import axios from 'axios';

export default {
  getAirportList
};

const GET_AIRPORTS_V1 = 'catalog/api/v1/airport';

function getAirportList(searchAirport, ignoreCode, ignoreAirport) {
  const request = {
    searchAirport,
    ignoreCode,
    ignoreAirport
  };

  return new Promise((resolve, reject) => {
    axios
      .get(GET_AIRPORTS_V1, {
        params: request
      })
      .then(res => resolve(res))
      .catch(err => resolve([]));
  });
}



// WEBPACK FOOTER //
// ./src/services/airport/AirportService.js